<script setup lang="ts">
useHead({
  htmlAttrs: {
    lang: "en",
  },
  meta: [
    { name: "viewport", content: "width=device-width, initial-scale=1" },
  ],
  link: [
    { rel: "icon", href: "/favicon.ico" },
  ],
});

useSeoMeta({
  ogImage: "/og-main.png",
  ogImageAlt: useRuntimeConfig().public.appName,
});

useSchemaOrg([
  defineOrganization({
    // We augment the default organization identity generated by Nuxt SEO with our own founder
    founder: {
      "@type": "Person",
      "name": "Yusuf Mansur Özer",
      "sameAs": [
        "https://ymo.dev",
        "https://x.com/ymansurozer",
        "https://linkedin.com/in/ymansurozer",
        "https://github.com/ymansurozer",
      ],
    },
  }),
]);
</script>

<template>
  <div>
    <NuxtLoadingIndicator />
    <UNotifications />

    <div>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>

    
  </div>
</template>

<style>
h1, h2, h3, h4, h5, h6 {
@apply font-serif
}
</style>
